import { createContext, useContext, useEffect, useState } from "react";
import { dashApi, setDashToken, clearDashToken, getDashToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const boot = async () => {
      if (getDashToken()) {
        try { setUser(await dashApi.me()); }
        catch { clearDashToken(); clearToken(); }
      }
      setLoading(false);
    };
    boot();
  }, []);

  const login = async (identifier, password) => {
    const data = await dashApi.login(identifier, password);
    setDashToken(data.access_token);
    if (data.sos_token) setToken(data.sos_token);
    const u = { role: data.role, name: data.name, email: data.email };
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await dashApi.logout(); } catch { /* best effort */ }
    clearDashToken(); clearToken(); setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
